module.exports = __webpack_public_path__ + "img/green-btn.c98bb035.svg";